export default {
      id: "icon-arrow-down-no-shaft-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-down-no-shaft",
      toString: function () {
        return this.url;
      }
    }